<template>
	<div class="navigation" :class="{ 'active': showNavigation }">
		<div class="navigation-header">
			<div class="navigation-header-logo">
				Komparo
			</div>
			<div class="navigation-header-handler" @click.prevent="closeNavigation()">
				<i class="el-icon-close"></i>
			</div>
		</div>
		<div class="navigation-body">
			<ul class="navigation-body-list">
				<li>
					<router-link to="/analytics" @click.native="handleRedirect('/analytics')">
						<i class="el-icon-pie-chart"></i>
						<span>Analytics</span>
					</router-link>
				</li>
				<li>
					<router-link to="/applications" @click.native="handleRedirect('/applications')">
						<i class="el-icon-date"></i>
						<span>Applications</span>
					</router-link>
				</li>
				<li v-if="user.role === 1">
					<router-link to="/users" @click.native="handleRedirect('/users')">
						<i class="el-icon-user"></i>
						<span>Users</span>
					</router-link>
				</li>
				<li v-if="user.role === 1">
					<router-link to="/sources" @click.native="handleRedirect('/sources')">
						<i class="el-icon-wallet"></i>
						<span>Sources</span>
					</router-link>
				</li>
			</ul>
		</div>
		<div class="navigation-bottom">
			<div class="navigation-bottom-user">
				<div class="navigation-bottom-user-avatar" :class="{ 'active': showProfile }" @click.prevent="toggleProfile()" ref="toggle">
					<vue-letter-avatar v-if="user.first_name" :name="user.first_name" size="32" :rounded="true" />
				</div>
				<div class="navigation-bottom-user-menu" :class="{ 'active': showProfile }">
					<div class="navigation-bottom-user-menu-top">
						<vue-letter-avatar v-if="user.first_name" :name="user.first_name" size="32" :rounded="true" />
						<div class="navigation-bottom-user-menu-top-data">
							{{ user.first_name }} {{ user.last_name }}<br />
						</div>
					</div>
					<div class="navigation-bottom-user-menu-body">
						<ul>
							<li @click="handleRedirect('/profile')">
								<i class="el-icon-s-custom"></i>Profile
							</li>
							<li @click="handleLogOut()">
								<i class="el-icon-lock"></i>Logout
							</li>
						</ul>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueLetterAvatar from 'vue-letter-avatar'
import { mapState } from 'vuex'
import { HTTP } from '@/services/api'

Vue.use(VueLetterAvatar)

export default {
	name: 'Navigation',
	data () {
		return {
			showProfile: false
		}
	},
	computed: {
		...mapState(['user', 'showNavigation'])
	},
	watch: {
		'$route' () {
			this.$store.dispatch('setNavigation', false)
			this.showProfile = false
		}
	},
	mounted () {
		window.addEventListener('click', this.handleProfileClose)
	},
	destroyed () {
		window.removeEventListener('click', this.handleProfileClose)
    },
	methods: {
		closeNavigation () {
			this.$store.dispatch('setNavigation', false)
		},
		toggleProfile () {
			this.showProfile = !this.showProfile
		},
		handleRedirect (value) {
			this.$router.push(value, () => {})
			this.closeNavigation()
		},
		handleProfileClose (e) {
			if (!this.$el.contains(e.target)) {
				this.showProfile = false
			}
		},
		handleLogOut () {
			this.loading = true
			return HTTP({
				method: 'POST',
				url: '/logout',
				crossdomain: true
			})
			.then(() => {
				setTimeout(() => {
					this.$store.dispatch('setNavigation', false)
					this.$router.push('/')
					this.$store.dispatch('logout')
				}, 500)
			})
		}
	}
}
</script>
